/**
 * Serializes an error object for Redux state storage.
 * Extracts only serializable properties from AxiosError or other error types.
 */
export interface SerializedError {
  message: string;
  code?: string;
  status?: number;
  statusText?: string;
}

export const serializeError = (err: any): SerializedError => {
  return {
    message: err?.message || err?.toString() || "Unknown error",
    code: err?.code,
    status: err?.response?.status,
    statusText: err?.response?.statusText,
  };
};
